/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/monday" */ '@atlassian/logo-third-party/monday'
		).then((m) => m.MondayIcon),
	{ moduleId: '@atlassian/logo-third-party/monday' },
);

const LazyMondayIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-monday" */ './utils').then((m) => m.MondayIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/monday/icon' },
);

const LazyMondaySearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-monday-search-result" */ './utils').then(
			(m) => m.MondaySearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon' },
);

const LazyMondayIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-monday-borderless" */ './utils').then(
			(m) => m.MondayIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const MondayIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyMondayIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const MondaySearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyMondaySearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);

export const MondayIconBorderless: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyMondayIconBorderlessComponent />
		</Suspense>
	),
	OfficialIcon,
	'xxsmall',
);
